export const adicionaFormaPgtoEntradaImob = formaPgto => ({
  type: '@vendas/ADICIONA_FORMA_PAGAMENTO_ENTRADA_IMOB',
  payload: formaPgto,
});

export const removeFormaPgtoEntradaImob = (item, index) => ({
  type: '@vendas/REMOVE_FORMA_PAGAMENTO_ENTRADA_IMOB',
  payload: {
    item,
    index,
  },
});

export const atualizaFormaPgtoEntradaImob = (formaPgto, index) => ({
  type: '@vendas/ATUALIZA_FORMA_PAGAMENTO_ENTRADA_IMOB',
  payload: {
    formaPgto,
    index,
  },
});

export const removeTodasParcelasEntradaImob = () => ({
  type: '@vendas/REMOVE_TOTAS_PARCELAS_ENTRADA_IMOB',
});
